// Dashboard calendar dates follow the clinic setting, never the browser zone.
const timezone = value => {
    try {
        if (typeof value === 'string' && value.trim()) {
            new Intl.DateTimeFormat('fr-FR', { timeZone: value.trim() }).format(0)
            return value.trim()
        }
    } catch (error) { /* Match the API fallback for an invalid setting. */ }
    return 'UTC'
}

const instant = value => {
    if (value === null || value === undefined || value === '') return null
    let source = value
    // Legacy unqualified timestamps are storage instants (UTC), not local times.
    if (typeof source === 'string') {
        source = source.replace(' ', 'T')
        if (/^\d{4}-\d{2}-\d{2}(T\d{2}:\d{2}(:\d{2}(\.\d+)?)?)?$/.test(source)) source += source.includes('T') ? 'Z' : 'T00:00:00Z'
    }
    const date = new Date(source)
    return Number.isNaN(date.getTime()) ? null : date
}

const parts = (value, zone) => {
    const date = instant(value)
    if (!date) return null
    const result = {}
    new Intl.DateTimeFormat('fr-FR', {
        timeZone: timezone(zone), year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
    }).formatToParts(date).forEach(part => { if (part.type !== 'literal') result[part.type] = part.value })
    return result
}

const day = (value, zone) => {
    const date = parts(value, zone)
    return date ? [date.year.padStart(4, '0'), date.month, date.day].join('-') : ''
}

const duration = seconds => {
    if (!Number.isFinite(Number(seconds)) || Number(seconds) < 0) return '—'
    const minutes = Math.floor(Number(seconds) / 60)
    if (!minutes && Number(seconds) > 0) return '< 1 min'
    const days = Math.floor(minutes / 1440)
    const hours = Math.floor((minutes % 1440) / 60)
    const remaining = minutes % 60
    return [days ? days + ' j' : '', hours ? hours + ' h' : '', remaining || (!days && !hours) ? remaining + ' min' : ''].filter(Boolean).join(' ')
}

export default { timezone, instant, parts, day, duration }
